<script lang="ts">
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput'
import NrModal from '@nextrequestco/components/src/components/NrModal'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation'

export default defineComponent({
  name: 'request-custom-fields',
  components: {
    NrTooltip,
    NrIconButton,
    NrModal,
    NrFormInput,
    NrLoadingAnimation
  },
  props: {
    prettyId: { type: String },
    fields: { type: Array }
  },
  data() {
    return {
      showModal: false,
      tmp: {
        slug: null,
        label: null,
        value: null
      }
    }
  },
  computed: {
    ...mapState('request_show', ['request', 'filteredRequestLoading'])
  },
  methods: {
    ...mapActions('request_show', ['updateCustomField']),

    resetForm() {
      this.tmp = {
        slug: null,
        label: null,
        value: null
      }
    },

    handleEditField(slug: string | null = null) {
      this.showModal = true
      const activeField = this.fields.find(
        (field: { slug: string; label: string; value: any }) =>
          field.slug === slug
      )
      if (!activeField) {
        return
      }
      this.tmp = activeField
    },

    handleCloseModal() {
      this.showModal = false
      this.resetForm()
    },

    handleUpdate() {
      this.$toasted.success('Additional information updated successfully')
      this.updateCustomField({
        prettyId: this.prettyId,
        field: this.tmp
      })
      this.handleCloseModal()
    }
  }
})
</script>

<template>
  <article class="panel custom-fields-panel p-bottom-4">
    <p
      class="panel-heading has-background-light has-text-weight-semibold is-size-4"
    >
      Additional information
    </p>
    <div class="panel-content" v-if="!filteredRequestLoading">
      <div
        v-for="field in fields"
        :key="field.slug"
        class="panel-content-section"
      >
        <div
          class="panel-item is-flex is-align-items-center is-justify-content-space-between"
          :class="{
            'panel-item--editable': $can('manage', 'Request')
          }"
        >
          <p class="has-text-weight-semibold">{{ field.label }}</p>
          <NrTooltip label="Edit" v-if="$can('manage', 'Request')">
            <NrIconButton
              variant="minimal-neutral"
              :icon="{ name: 'pencil-alt', type: 'regular' }"
              :aria-label="`Edit: ${field.label}`"
              @click="handleEditField(field.slug)"
            />
          </NrTooltip>
        </div>

        <div class="panel-item">
          <p class="m-left-8 m-bottom-12">
            <span v-if="!!field.value">
              {{ field.value }}
            </span>
            <span v-else class="is-italic">No data entered</span>
          </p>
        </div>
      </div>
    </div>
    <NrLoadingAnimation v-else :count="3" />

    <NrModal
      title="Edit additional information"
      secondaryButtonText="Cancel"
      primaryButtonText="Update information"
      :hasSecondaryButton="true"
      :show="showModal"
      @on-close-click="handleCloseModal"
      @on-secondary-click="handleCloseModal"
      @on-primary-click="handleUpdate"
    >
      <form @submit.prevent.stop>
        <fieldset>
          <NrFormInput
            id="custom-field"
            :label="tmp.label"
            v-model="tmp.value"
          />
        </fieldset>
      </form>
    </NrModal>
  </article>
</template>
